module.exports = __webpack_public_path__ + "img/gmail.2ae41567.png";